import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { ClickAwayListener, DialogContentText, TextField } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { useTranslation } from 'react-i18next';
import {getReadableBarcode} from '../../../Helpers/generalHelper';

export default function TakeSampleDialog(props) {

    const classes = useStyles();
    const [palletForSample, setPalletForSample] = useState('');
    const [palletHasZero, setPalletHasZero] = useState(false);
 
    const palletForSampleChanged = (e) => {
        if (e.target.value.length > 18) {
            if(getReadableBarcode(e.target.value) !== e.target.value){
                setPalletHasZero(true)
            }
            setPalletForSample(getReadableBarcode(e.target.value))
        }else{
            setPalletForSample(e.target.value)
        }
    }
    const { t } = useTranslation();
    let totalPallets = 0;
    let progress = 0;

    if (props.productionOrder) {
        if (props.productionOrder.bomOut.length > 0) {
            totalPallets = Math.ceil(props.productionOrder.bomOut[0].quantityToProduce / props.productionOrder.bomOut[0].quantityOnCarrier)
        }

        if(parseInt(props.progress) === totalPallets){
            progress = totalPallets
        }
        else{
            progress =  parseInt(props.progress) + 1
        }   

    }


    return (
        <Dialog className={classes.dialogContainer}
            open={props.dialogOpen}
            onClose={props.closeDialog}
            aria-labelledby="draggable-dialog-title"
            //onBackdropClick={true}
        >    <div className={classes.headerIcon}> <img className={classes.menuIcon} alt="delete" src={process.env.PUBLIC_URL + '/img/sample.svg'}></img>
            </div>
            <DialogTitle className={classes.dialogTitle} style={{ cursor: 'move' }} id="draggable-dialog-title">
                {props.dialogTitle}
            </DialogTitle>
            <div className={classes.dialogContext}>
                <div className={classes.plateInfo}>{props.dialogContext}</div>
                <div className={classes.palletProgress}>
                    {"Pallet " + (progress) + "/" + totalPallets}
                </div>
                <div className={classes.label}>
                    {t("Pallet Number")}
                </div>
                <div className={classes.textfield}>
                    <TextField id="outlined-search" label="" type="search" variant="outlined" value={palletForSample }   className={classes.uiTextField} size="small" onChange={(e) => palletForSampleChanged(e)} />
                    </div>
            </div>
            <DialogActions>
                <div className={classes.buttons}>
                    <Button className={classes.performTestButton} autoFocus onClick={() => props.action(palletForSample, props.progress)}>
                        {t("PERFORM TEST")}
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
}


const useStyles = makeStyles(() => ({

    dialogContainer: {
        width: "520px !important",
        height: "420px !important",
        margin: "auto",
        "& > div > div": {
            backgroundImage: 'linear-gradient(#EFEFEF,#FFFFFF)',
            maxHeight: "none"
        },
    },
    buttons: {
        width: "520px",
        textAlign: "center"
    },
    performTestButton: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        backgroundColor: FlagstoneTheme.palette.primary.main,
        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
        },
        margin: "3px",
        width: "160px",
        marginBottom: "30px",
        marginTop: "40px"
    },
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        '& h2': {
            fontSize: "32px !important",
        },
        paddingTop: "0px",
        paddingBottom: "0px"
    },
    dialogContext: {
        color: "#000000",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        paddingLeft: "50px",
        paddingRight: "50px",
        height: "90px"
    },
    headerIcon: {
        height: "80px",
        width: "100%",
        marginTop: "20px",
        textAlign: "center",
        padding: "20px",
        boxSizing: "border-box"
    },
    uiTextField: {
        width: "100%",
        backgroundColor: "white"
    },
    label: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#020100",
        textAlign: "left"
    },
    palletProgress: {
        width: "100%",
        textAlign: "center",
        marginBottom: "10px",
        marginTop: "10px"
    }
}));
